import React, { useEffect, useState } from "react";
import './style.css';
import StandardIcon from "../../../assets/images/NicoLogo.webp";

function ListItemProducto({item, list, setList, tipo, jsonSave, onClick}){

    let cant = 0;

    useEffect(() => {
        if(list != null){
            for(let i = 0; i < list.length; i++){
                if(list[i].descripcion === item.descripcion){
                    cant = list[i].cantidad + 1;
                }
            }
        }
    })

    /*
    function setOnList(){
        
        if(jsonSave){
            if(list.length == 5){
                item.cantidad = 1;
                item.cantPendiente = 1;
                jsonSave = false;
                setList(item);
            }else{
                jsonSave = false;
            }
        }
        
        
        if(list != null && setList != null){
            item.cantidad = 1;
            item.cantPendiente = 1;
            if(list.length <= 0){
                setList([item]);
            }else{
                let found = false;
                for(let i = 0; i < list.length; i++){
                    if(list[i].descripcion === item.descripcion){
                        list[i].cantidad = cant;
                        list[i].cantPendiente = cant;
                        found = true;
                        setList([...list]);

                    }else if(i === list.length - 1){
                        if(!found){
                            setList([...list, item]);
                        }
                    }
                }
            }
        }

        setAlert(true);
    }
    */

    return (
        <div className="list-item-producto" id={item.id} onClick={onClick}>
            <p className="producto-text" id="id">{item.id}</p>
            <p className="producto-title" id="descripcion">{item.descripcion}</p>
            <p className="producto-title" id="dStock">Stock</p>
            <p className="producto-text" id="stock">{item.stock != null && item.stock > 0 ? "EN STOCK" : "SIN STOCK"}</p>
            <p className="producto-title" id="dPrecio">Precio</p>
            <p className="producto-text" id="precio">{Intl.NumberFormat('es-AR', {style:"currency", currency:"ARS", maximumFractionDigits: 0}).format(tipo == 2 ? item.lista2 : item.lista1)}</p>
            <p className="producto-title" id="dRubro">Rubro</p>
            <p className="producto-text" id="rubro">{item.idRubro == 4 && "INSUMOS"}{item.idRubro == 2 && "REPUESTOS"}</p>
            <p className="producto-title" id="dSrubro">Subrubro</p>
            <p className="producto-text" id="srubro">{item.idSubrubro == 13 && "AUTOMOTOR"}{item.idSubrubro == 14 && "COMERCIAL"}{item.idSubrubro == 16 && "FAMILIAR"}{item.idSubrubro < 13 && "VARIOS"}</p>
        </div>
    ); 
}

export default ListItemProducto;